import { setActiveIconId } from "store/features/memeGenerator/actions";
import { store, useAppDispatch, useAppSelector } from "store/store";

export const useIconSettingsMobile = () => {
    const activeIconId = useAppSelector((state) => state.memeGenerator.meme?.activeIconId);
    const dispatch = useAppDispatch();
    function handleOutsideClick() {
        dispatch(setActiveIconId(undefined));
    }
    return {
        activeIconId,
        handleOutsideClick,
    };
};
